// @ts-nocheck
import { arrayOf, shape } from 'prop-types'
import { type FunctionComponent } from 'react'
import * as React from 'react'

import { CartControllerCartEntryItemV2 } from 'types/api/cart'
import ProductImage from 'views/components/organisms/ProductImage'

type ProductImageListProps = {
  products: CartControllerCartEntryItemV2[]
}

export const ProductImageListCart: FunctionComponent<ProductImageListProps> = ({
  products,
}): React.ReactElement => {
  return (
    <div className="l-flex">
      {products.map((product, idx) => {
        return (
          <div
            key={`${product.brandName}-${product.productName}-${product.offerId}`}
            className={`${products.length !== idx + 1 && 'u-margin--right'}`}
          >
            <ProductImage
              thumbnail
              imageUrl={product.imageUrl}
              name={`Product ${product.brandName}`}
              sizes={{ base: '3em' }}
              srcWidth={42}
              srcHeight={42}
              minWidth={42}
              maxWidth={42}
              tighterThumbnailWithDarkBackground
            />
          </div>
        )
      })}
    </div>
  )
}

ProductImageListCart.propTypes = {
  products: arrayOf(shape({})).isRequired,
}

// ProductImageListCart.defaultProps = {}
